// extracted by mini-css-extract-plugin
export default {"announcements-trigger":"xpphH","announcements-content":"_3fYKH"};